import React, {
  ComponentType
} from 'react'
import {
  Grid,
  Icon,
  Message
} from 'semantic-ui-react'
// Local
import { isReadyForCdiQa } from '../../common/reviewUtils'
import { isCdiQaManager } from '../../common/roleUtils'
import {
  Encounter,
  EncounterReviewer,
  User
} from '../../authenticated/types'

const SafeMessage = Message as unknown as ComponentType<any>

type CdiEncounterMessageProps = {
  encounter: Encounter
  currentUser: User
  mode?: string
}

/**
 * Provides a component that displays encounter level messages. If there are
 * no messages to display, the return is null
 * @param encounter Encounter entity
 * @param currentUser Current user entity
 * @param mode Render mode. Either undefined, or "grid"
 */
function CdiEncounterMessage(props: CdiEncounterMessageProps): JSX.Element | null {
  const {
    encounter,
    currentUser,
    mode
  } = props

  const getReviewerName = (reviewer: EncounterReviewer | null): string | null => {
    if (reviewer) {
      return `${reviewer.firstName} ${reviewer.lastName}`
    }
    return null
  }

  const renderMessages = (messages: string[]): JSX.Element | null => {
    if (messages.length > 1) {
      return (
        <SafeMessage warning>
          <Icon name="info circle" />
          <ul>
            { messages.map((message, i) => {
              const messageKey = message.length > 0
                ? `message-${message.substring(0, 20).replace(/\s/g, '-')}-${i}`
                : `message-${i}`
              return <li key={ messageKey }>{ message }</li>
            }) }
          </ul>
        </SafeMessage>
      )
    }
    if (messages.length === 1) {
      return (
        <SafeMessage warning>
          <Icon name="info circle" />
          { messages[0] }
        </SafeMessage>
      )
    }
    return null
  }

  const { review } = encounter
  const messages: string[] = []

  if (isReadyForCdiQa(review) && !isCdiQaManager(currentUser.roles)) {
    const name = getReviewerName(review ? review.reviewer : null)
    if (name) {
      messages.push(`This encounter review is flagged for CDI QA review from ${name}`)
    } else {
      messages.push('This encounter review is flagged for CDI QA review')
    }
  }

  if (messages.length === 0) {
    return null
  }

  const messageUi = renderMessages(messages)
  if (mode === 'grid') {
    return (
      <Grid.Row>
        <Grid.Column width={ 16 }>{ messageUi }</Grid.Column>
      </Grid.Row>
    )
  }
  return messageUi
}

export default CdiEncounterMessage
